import { render, staticRenderFns } from "./PartStockList.vue?vue&type=template&id=36f32d89"
import script from "./PartStockList.vue?vue&type=script&lang=js"
export * from "./PartStockList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports